export default "__VITE_ASSET__258b5854__"